export default __webpack_public_path__ + "static/media/creatingpipelines.e6d243e4.png";